import { supabase } from "@/integrations/supabase/client";
import { generateSlug, ensureUniqueSlug } from "@/utils/slugify";

/**
 * Returns a showcase address (slug) not used by any organisation.
 * Prefers the server function (sees every organisation, regardless of what
 * the current user can view); falls back to the old browser-side check.
 */
export const resolveUniqueSlug = async (name: string, excludeId?: string): Promise<string> => {
  const base = generateSlug(name) || "organisation";
  try {
    const { data, error } = await (supabase as any).rpc("next_available_slug", {
      _base: base,
      _exclude_id: excludeId ?? null,
    });
    if (!error && typeof data === "string" && data) return data;
  } catch {
    /* fall back below */
  }
  let q = supabase.from("organizations").select("slug").like("slug", `${base}%`);
  if (excludeId) q = q.neq("id", excludeId);
  const { data: existing } = await q;
  return ensureUniqueSlug(base, ((existing || []) as any[]).map((o) => o.slug).filter(Boolean));
};

/** Postgres unique-violation code. */
export const isUniqueViolation = (e: any) => e?.code === "23505";
